<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div [ngClass]="'drawer drawer--glow ' + glowCss" *transloco="let t; prefix: 'pages.clinch.result'">
    <app-nav-button *ngIf="!isAfterGame" icon="xmark-circle" (clickEvent)="onCloseClick()"
        [size]="drawerConfig.closeButtonSize" [ngClass]="drawerConfig.closeButtonPosition" />

    <canvas id="myConfettiCanvas" [hidden]="worldWide"></canvas>

    <app-game-icon *ngIf="drawerConfig.hasGameIcon" [game]="viewModel.gameId" class="drawer__game-icon" />

    <app-game-title [title]="viewModel.gameName" class="drawer__game-name" />

    <div *ngIf="viewModel.subtitle && !worldWide" class="drawer__title typography-text-large-regular-secondary">
        {{ viewModel.subtitle }}
    </div>

    <div *ngIf="currencyAmount && !isFreeGame" class="drawer__currency typography-heading-x-large-bold-primary">
        <span class="ascii-icon" *ngIf="!worldWide">{{ viewModel.ascii }}</span>

        <span>{{ currencyAmount }}</span>
        <app-currency-icon *ngIf="currencyIcon" [icon]="currencyIcon" sizeCss="--icon-x-large"></app-currency-icon>
        <app-bounty-pill *ngIf="wonBountyAmount" size="large" [amount]="wonBountyAmount"/>
    </div>

    <div class="tournament-info" *ngIf="viewModel.tournamentTitle">
        <div class="typography-text-medium-regular-primary">
            {{ viewModel.tournamentTitle }}
        </div>
        <app-icon icon="trophy" colorCss="'var(--content-primary)'" sizeCss="--icon-medium" />
    </div>

    <div class="players nick">
        <div class="player">
            <div *ngIf="viewModel.playerName"
                role="button"
                class="typography-text-medium-semibold-primary typography--align--center player-name"
                (click)="onPlayerClick(viewModel.playerId)">
                {{ viewModel.playerName }}
            </div>
            <div *ngIf="!viewModel.playerName"
                role="button"
                class="typography-text-medium-semibold-primary typography--align--center player-name"
                (click)="onPlayerClick(currentUserId)">
                {{ t('you')}}
            </div>
            <app-icon icon="account" colorCss="--content-tertiary" sizeCss="--icon-medium" class="app-icon" />
        </div>
        <div class="player">
            <div class="typography-text-medium-semibold-primary typography--align--center"
                role="button"
                [ngClass]="{ 'player-name': viewModel.opponentId }" (click)="onPlayerClick(viewModel.opponentId)"
                *ngIf="viewModel.opponentName">
                {{ viewModel.opponentName }}
            </div>
            <app-icon icon="account" colorCss="--content-tertiary" sizeCss="--icon-medium" class="app-icon"
                *ngIf="viewModel.opponentName" />
        </div>
    </div>


    <div *ngIf="viewModel.scoreStatus === ScoreStatus.Finished" class="scoreboard">
        <div class="card card--nonhoverable">
            <div class="card-content">
                <div class="typography-text-large-semibold-primary typography--align--center">
                    {{ viewModel.yourScore }}
                </div>
            </div>
        </div>

        <div class="card card--nonhoverable">
            <div class="card-content">
                <div class="typography-text-large-semibold-primary typography--align--center">
                    {{ viewModel.opponentScore }}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="viewModel.scoreStatus !== ScoreStatus.Finished" class="scoreboard">

        <div class="card card--nonhoverable">
            <div class="card-content">
                <div class="nick typography-text-medium-regular-secondary typography--align--center">
                    {{ t('your-score')}}
                </div>
                <div class="typography-text-large-semibold-primary typography--align--center">
                    {{ viewModel.yourScore }}
                </div>
            </div>
        </div>

        <div class="card card--nonhoverable">
            <div class="card-content">
                <div class="typography-text-medium-regular-secondary typography--align--center">
                    {{ viewModel.opponentStatus }}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="viewModel.roomTimer && !isFreeGame && !OperatorService.IsDemo"
        class="drawer__title typography-text-large-regular-secondary">
        {{ viewModel.roomTimer.message$ | async }}
    </div>

    <div *ngIf="!isFreeGame && !OperatorService.IsDemo && !worldWide"
        class="drawer__title typography-text-small-regular-tertiary">
        ID: {{ viewModel.roomId }}
    </div>

    <div *ngIf="viewModel.freeCta && isFreeGame && !OperatorService.IsDemo && !worldWide"
        class="drawer__title typography-text-large-regular-secondary typography--align--center">
        <span>{{ viewModel.freeCta }}</span>
    </div>

    <app-button *ngIf="isAfterGame && !worldWide" [label]="t('finish')" layout="fill" (clickEvent)="onFinishClick()"
        class="drawer__button"></app-button>

    <ion-modal #modal [initialBreakpoint]="isMobile() ? 1 : undefined" [breakpoints]="isMobile() ? [0, 1] : undefined"
        handle="false" [backdropDismiss]="false" [canDismiss]="canDismiss" [ngClass]="{
          'desktop-rounded-modal': !isMobile(),
          'mobile-rounded-modal': isMobile()
        }">
        <ng-template>
            <app-player-stats-drawer [gameId]="viewModel.gameId" [userId]="statsUserId" />
        </ng-template>
    </ion-modal>
</div>